if(typeof flarum.core.compat['tags/forum/components/TagCard'] === 'undefined') { var e = new Error("Cannot find module 'flarum.core.compat['tags/forum/components/TagCard']'"); e.code = 'MODULE_NOT_FOUND'; throw e; }

module.exports = flarum.core.compat['tags/forum/components/TagCard'];